import React, { Component } from 'react';
import { connect } from 'react-redux';

import TableInfo from '../../components/TableInfo';
import { usersColumns } from '../../constants/usersColumns';
import {
    getUsersRequest,
    progressSelector,
    toggleUserActiveRequest,
    toggleUsersGroupActiveRequest,
    totalCountSelector,
    usersListSelector,
} from '../../ducks/users';
import {
    actionsCardSelector,
    allIdsSelector,
    clearActions,
    getActionsRequest,
    getAllIdsRequest,
    invokeActionRequest
} from "../../ducks/gridActions";
import { withTranslation } from 'react-i18next';
import UserCard from './user_card';
import { Button, Icon, Dropdown } from 'semantic-ui-react';
import RoleCard from '../roles/role_card';
import {
    DICTIONARY_CARD_LINK,
    DICTIONARY_NEW_LINK,
    NEW_USER_LINK,
    USER_LINK,
} from '../../router/links';

const newModal = (t, load) => (
    <UserCard title={t('create_user_title')} id={null} loadList={load}>
        <Button icon="add" />
    </UserCard>
);

export class UsersList extends Component {
    handleToggleIsActive = (itemID, checked, load) => {
        const { toggleActive } = this.props;
        toggleActive({
            id: itemID,
            active: checked,
            callbackSuccess: () => {
                load(false, true);
            },
        });
    };

    handleToggleGroupIsActive = (rows, active, load) => {
        const { toggleActiveGroup } = this.props;
        const ids = [];
        for (const entry of rows) {
            ids.push(entry);
        }
        toggleActiveGroup({
            ids: ids,
            active: active,
            callbackSuccess: () => {
                load(false, true);
            },
        });
    };

    getActions = (row, load, t) => {
        return [
            <UserCard id={row.id} title={t('edit_user', { name: row.userName })} loadList={load}>
                <Button size="mini" className="grid-action-btn">
                    <Icon name="edit" /> {t('edit_btn')}
                </Button>
            </UserCard>,
        ];
    };

    getToggleActiveActions = () => {
        return [
            {
                color: "blue",
                name: "setUserIsActiveTrue",
                action: (ids, load) => {
                    this.handleToggleGroupIsActive(ids, true, load);
                }
            },
            {
                color: "red",
                name: "setUserIsActiveFalse",
                action: (ids, load) => {
                    this.handleToggleGroupIsActive(ids, false, load);
                }
            }
            
        ];
    };

    getCard = ({ row, loadList, name }) => {
        const { t } = this.props;

        return (
            <UserCard
                id={row.id}
                title={t('edit_user', { name: row.userName })}
                loadList={loadList}
            />
        );
    };

    render() {
        const { list, loadList, totalCount, loading, allIds, getAllIds, clearActions, t } = this.props;

        return (
            <TableInfo
                headerRow={usersColumns}
                name="users"
                loading={loading}
                checkboxDisplay={true}
                className="wider ui container container-margin-top-bottom"
                list={list}
                storageSortItem={`usersSort`}
                storageFilterItem={`usersFilters`}
                toggleIsActive={this.handleToggleIsActive}
                totalCount={totalCount}
                loadList={loadList}
                allIds={allIds}
                getAllIds={getAllIds}
                clearActions={clearActions}
                groupActions={this.getToggleActiveActions()}
                isShowGroupActions={true}
                newLink={NEW_USER_LINK}
                cardLink={USER_LINK}
                canEditRow={true}
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        list: usersListSelector(state),
        totalCount: totalCountSelector(state),
        loading: progressSelector(state),
        allIds: allIdsSelector(state),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadList: params => {
            dispatch(getUsersRequest(params));
        },
        toggleActive: params => {
            dispatch(toggleUserActiveRequest(params));
        },
        toggleActiveGroup: params => {
            dispatch(toggleUsersGroupActiveRequest(params));
        },
        getAllIds: params => {
            dispatch(getAllIdsRequest(params));
        },
        clearActions: params => {
            dispatch(clearActions(params));
        },
    };
};

export default withTranslation()(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(UsersList),
);
